import { render } from "./ReferralForm.vue?vue&type=template&id=0655a9d2&scoped=true"
import script from "./ReferralForm.vue?vue&type=script&lang=js"
export * from "./ReferralForm.vue?vue&type=script&lang=js"

import "./ReferralForm.vue?vue&type=style&index=0&id=0655a9d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0655a9d2"]])

export default __exports__